exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/admin/shared/formcontrol-subdocument/formcontrol-subdocument.component.scss
// module id = 272
// module chunks = 0 1